import { render, staticRenderFns } from "./search-with-button.vue?vue&type=template&id=65beea80&"
import script from "./search-with-button.vue?vue&type=script&lang=js&"
export * from "./search-with-button.vue?vue&type=script&lang=js&"
import style0 from "./search-with-button.vue?vue&type=style&index=0&id=65beea80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzSearchWithButton: require('/opt/airport.kg/node_modules/razlet-ui/src/components/search-with-button/index.vue').default})
